module.exports = __webpack_public_path__ + "media/images/top-service-02-821794d30cc9a1290585b6203d70eee6.jpg";